<template>
  <form @submit.prevent="submit" class="community-send-comment">
    <div class="comment-picture mr-4">
      <img v-if="userAvatar" class="user-avatar" :src="userAvatar" alt="" />
      <span v-else>{{ nameInitial }}</span>
    </div>
    <div class="comment-box">
      <form-group
        placeholder="Comentar..."
        id="text"
        v-model="form.text"
        :errors="errors.text"
        textarea
      />
      <button class="btn btn-sm btn-primary px-5" :disabled="loading">
        <loading :show="loading">Enviar</loading>
      </button>
    </div>
    <!-- <button
      class="btn btn-secondary px-5 rounded-pill ml-3"
      v-if="parent"
      @click="$emit('cancel')"
    >
      Cancelar
    </button> -->
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  props: {
    lesson: {
      type: [Number, String],
      default: null
    },
    parent: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      ...formFields(["text"])
    };
  },
  computed: {
    userAvatar() {
      return this.$user.user.avatar;
    },
    nameInitial() {
      return this.$user.user.name[0];
    }
  },
  methods: {
    submit() {
      this.loading = true;
      const data = {
        ...this.form,
        lesson_id: this.lesson
      };
      if (this.parent) {
        data.parent_id = this.parent;
      }
      this.$store
        .dispatch("forum/add", data)
        .then(() => {
          this.$message.success("Comentário enviado com sucesso");
          this.form.text = "";
          this.$emit("success");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-send-comment {
  display: flex;

  ::v-deep .form-control {
    background-color: #1f1f1f;
    border: none;
    border-radius: 0px;
    resize: none;
    position: relative;
    color: white;
    height: 30px;
    overflow-y: visible;
    padding: 0px;

    &::placeholder {
      color: #d2d0d8;
    }
    &:focus {
      box-shadow: none;
    }
  }
  .comment-picture {
    border-radius: 50%;
    background-color: #919191;
    min-width: 48px;
    max-width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .user-avatar {
    height: 48px;
    width: 48px;
    object-fit: cover;
    border-radius: 48px;
  }

  .comment-box {
    position: relative;
    width: 100%;
    background-color: #1f1f1f;
    padding: 16px 20px;
    padding-right: 180px;
    height: 72px;
  }

  button {
    position: absolute;
    top: 20px;
    right: 18px;
    height: 32px;
    font-weight: 500;
    font-size: 16px;
  }
}
</style>
